module.exports = __webpack_public_path__ + "static/media/dior-homme.70e01316.png";